import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import posthog from 'posthog-js'
import "@/index.css";
import App from "@/App";

posthog.init('phc_uKcNhjam7ZLwhreRUAMG73a8yPhUAn8XKi6ikFaXxyJN', {
  api_host: 'https://eu.posthog.com',
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
})

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV || "production",
    release: "flitship@1.0.0",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      "Network request failed",
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
